// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"56":"137fbadb","182":"7c9bf593","192":"3ad13cd6","464":"dbe40b59","491":"5a00f194","524":"d2c7288e","820":"67a40f0a","823":"17afa95e","873":"d124b201","877":"c9535597","924":"1a957580"}[chunkId] + ".chunk.js";
};